<template>
  <generic-trash
    v-model="selected"
    :getPag="getPagAux"
    :getExcel="getExcelAux"
    :getParams="getParamsAux"
    :doRestore="doRestoreAux"
    :doDelete="doDeleteAux"
    :FilterPanel="FilterPanel"
    :RouteName="RouteName"
    :dialogTitle="dialogTitle"
    :dialogMesage="dialogMesage"
    :ExcelName="ExcelName"
    :idVista="idVista"
    :HeaderTitle="HeaderTitle"
    :vuexnamespace="vuexnamespace"
    :PayloadSingleId="PayloadSingleId"
    :PayloadMultipleId="PayloadMultipleId"
  />
</template>

<script>
import { i18n } from '@/i18n'

import GenericTrash from '@/views/trash/GenericTrash.vue'
import CustomFilter from '@/components/filters/trash/SociedadesFilter.vue'

import { getSociedadesPag } from '@/services/configurations/getSociedadesPag'
import { getSociedadesExcel } from '@/services/configurations/getSociedadesExcel'
import { deleteTrashSociedad } from '@/services/trash/deleteTrashSociedad'
import { restoreTrashSociedad } from '@/services/trash/restoreTrashSociedad'

export default {
  name: 'vista-papelera-agenda',
  components: {
    GenericTrash,
  },
  data: function () {
    return {
      FilterPanel: CustomFilter,
      RouteName: 'society',
      dialogTitle: i18n.t('agenda.delete_sociedades'),
      dialogMesage: i18n.t('app.delete_permanent_selected_confirmation_f', { entity: i18n.t('agenda.sociedad_plural').toLowerCase() }),
      ExcelName: `${i18n.t('agenda.deleted_sociedades').replaceAll(' ', '-').toLowerCase()}.xlsx`,
      idVista: 59,
      HeaderTitle: i18n.t('agenda.deleted_sociedades'),
      vuexnamespace: 'trashSociedades',
      PayloadSingleId: 'IdSociedad',
      PayloadMultipleId: 'IdSociedades',
      selected: []
    }
  },
  computed: {
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
  },
  methods: {
    getParamsAux (data) {
      return {
        borrado: true,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        NameCorporateName: data.NameCorporateName ? data.NameCorporateName.value : null,
        TIN: data.TIN ? data.TIN.value : null,
        FirstSurname: data.FirstSurname ? data.FirstSurname.value : null,
        SecondSurname: data.SecondSurname ? data.SecondSurname.value : null,
        ResidenceType: data.ResidenceType ? data.ResidenceType.value : null,
        PersonType: data.PersonType ? data.PersonType.value : null,
        Locations: data.Locations ? data.Locations.value : null,
        LinkedCompanies: data.LinkedCompanies ? data.LinkedCompanies.value : null,
        Book: data.Book ? data.Book.value : null,
        RegisterOfCompaniesLocation: data.RegisterOfCompaniesLocation ? data.RegisterOfCompaniesLocation.value : null,
        Sheet: data.Sheet ? data.Sheet.value : null,
        Folio: data.Folio ? data.Folio.value : null,
        Section: data.Section ? data.Section.value : null,
        Volume: data.Volume ? data.Volume.value : null,
        AdditionalData: data.AdditionalData ? data.AdditionalData.value : null,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getSociedadesPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      return await getSociedadesExcel(objOrder, params)
    },
    doRestoreAux: async function (payload) {
      return await restoreTrashSociedad(payload)
    },
    doDeleteAux: async function (payload) { 
      return await deleteTrashSociedad(payload)
    },
  }
}
</script>
